const USER = process.env.REACT_APP_NAME + process.env.REACT_APP_LOCAL_STORAGE_TOKEN;

class UserUtil {
  getUser() {
    const user = localStorage.getItem(USER);
    return JSON.parse(user);
  }

  setUser(user: any) {
    return localStorage.setItem(USER, JSON.stringify(user));
  }

  clearUser() {
    return localStorage.setItem(USER, null);
  }

  setCurrentRole(role: any) {
    const user = this.getUser();
    user.currentRole = role;
    return user;
  }
}

// follows singletons object of class
export default new UserUtil();
